// eslint-disable-next-line import/prefer-default-export
export const handleScroll = (onScrollCallback) => {
  window.removeEventListener('scroll', onScrollCallback);
  window.addEventListener('scroll', onScrollCallback, { passive: true });

  return () => window.removeEventListener('scroll', onScrollCallback);
};
